import { AllocatedLab, PassOrFail } from "@gtpl/shared-models/common-models";

export class AntibioticsReq {

    fromDate?:Date;
    toDate?:Date;
    indentNumber?: number;
    grnNumber?:number;
    lotNumber?:number;
    status?:PassOrFail;
    allotedLab?:AllocatedLab
    testAt?:string
    page?:number;
    pageSize?:number

    constructor(
        fromDate?:Date,
        toDate?:Date,
        indentNumber?: number,
        grnNumber?:number,
        lotNumber?:number,
        status?:PassOrFail,
        allotedLab?:AllocatedLab,
        testAt?:string,
        page?:number,
        pageSize?:number


    ){
        this.fromDate= fromDate
        this.toDate = toDate
        this.indentNumber = indentNumber
        this.grnNumber = grnNumber  
        this.lotNumber = lotNumber
        this.status = status
        this.allotedLab = allotedLab
        this.testAt = testAt
        this.page = page
        this.pageSize = pageSize
        
    }
}
